import axios from "axios";

const connection = process.env.REACT_APP_AUTH_CONNECTION;
const connectionId = process.env.REACT_APP_AUTH_CONNECTION_ID;

export function login({ email, password }) {
  return axios.post("/account/system-admin/sign-in", {
    connection,
    connection_uuid: connectionId,
    email,
    password,
  });
}

export function checkSession({ sessionId, sessionExpiration }) {
  return axios.get("/account/api/session/check-session", {
    headers: {
      "Session-Id": sessionId,
      "Session-Expiration": sessionExpiration,
    },
  });
}

export function bootstrap() {
  return axios.get("/account/system-admin/api/v1/bootstrap");
}

export function signOut({ sessionId, sessionExpiration }) {
  return axios.post("/account/system-admin/sign-out", {}, {
    headers: {
      "Session-Id": sessionId,
      "Session-Expiration": sessionExpiration,
    },
  });
}
